import { useKeycloak } from "@react-keycloak/web";
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import useLandingAuthApi from "../services/api/useLandingAuthApi";

const FormDataContext = createContext();

export { FormDataContext }; // Export the context so it can be used in tests

export const useFormData = () => useContext(FormDataContext);

export const FormDataProvider = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const { fetchUserProfile } = useLandingAuthApi();

  const [userData, setUserData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    phone: "",
    addressLineOne: "",
    addressLineTwo: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    associations: [],
    email: "",
    role: "",
  });

  const [isProfileFetched, setIsProfileFetched] = useState(false);

  const fetchUserData = useCallback(async () => {
    if (!initialized || !keycloak.authenticated || isProfileFetched) return;

    try {
      const keycloakProfile = await keycloak.loadUserProfile();
      const userProfile = await fetchUserProfile();
      const roles = keycloak.tokenParsed.realm_access.roles;
      setUserData({
        ...keycloakProfile,
        ...userProfile,
        role: roles.includes("REVIEW_TRIPS") ? "REVIEW_TRIPS" : "",
      });
      setIsProfileFetched(true);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }, [initialized, keycloak, fetchUserProfile, isProfileFetched]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return (
    <FormDataContext.Provider value={{ userData, setUserData }}>
      {children}
    </FormDataContext.Provider>
  );
};
